<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.payment.setup.feeSetup.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('school.payment.setup.feeSetup.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'fee-setup-create' })"
              >{{ $t('add_new') }}</ts-button
            >
            <ts-button class="ml-2" @click.prevent="showFormCopy">{{
              $t('school.payment.setup.feeSetup.copyFee')
            }}</ts-button>
            <ts-button
              outline
              color="success"
              class="ml-2"
              @click.prevent="exportExcel"
              :waiting="exporting"
            >
              <i class="fas fa-file-excel"></i>
              {{ $t('export') }}</ts-button
            >
          </div>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="showFilter"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            row-key="index"
            :columns="columns"
            :data="groupResources"
            :span-method="handleSpan"
            size="small"
            :loading="loading"
            highlight-row
            stripe
            max-height="700"
          >
            <template slot-scope="{ row }" slot="branch_name_en">
              {{ row.branch ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="grade_name_foreign">
              {{ row.grade ? row.grade.grade_name_foreign : '' }}
            </template>
            <template slot-scope="{ row }" slot="payment_term">
              {{ row.payment_term ? row.payment_term.payment_term : '' }}
            </template>
            <template slot-scope="{ row }" slot="shift_en">
              {{ row.shift ? row.shift.shift_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="grade">
              {{ displayMainProgram(row.grade) }}
            </template>
            <template slot-scope="{ row }" slot="academic_year">
              {{ row.academic_year ? row.academic_year.ac_year : '' }}
            </template>
            <template slot-scope="{ row }" slot="distance_description">
              {{ row.distance ? row.distance.distance_description : '' }}
            </template>
            <template slot-scope="{ row }" slot="way_description">
              {{ row.way ? row.way.way_description : '' }}
            </template>
            <template slot-scope="{ row }" slot="loginname">
              {{ row.user ? row.user.loginname : '' }}
            </template>
            <template slot-scope="{ row }" slot="inactive">
              <a-switch
                :checked="row.inactive"
                size="small"
                :loading="row.inactive"
                @change="setToInactive(row)"
              />
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                v-if="defaultBranchId === row.branch_id"
                href="#"
                title="Edit"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                v-if="defaultBranchId === row.branch_id"
                href="#"
                title="Delete"
                class="text-danger"
                @click.prevent="destroy(row)"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('invoice.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="onCloseDrawer"
        :zIndex="1020"
        width="300px"
      >
        <ts-loading-banner :loading="waiting_fetch">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('school.payment.setup.feeSetup.branch') }}</label>
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="filterOptions"
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                  @change="onBranchgChange"
                >
                </a-select>
              </div>
              <div class="form-group">
                <label>{{
                  $t('school.payment.setup.feeSetup.academicYear')
                }}</label>
                <a-select
                  style="width: 257px"
                  v-model="ac_year_id"
                  :options="academicYear"
                  showSearch
                  mode="multiple"
                  :filterOption="filterOptions"
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
              <div class="form-group">
                <label>{{ $t('school.payment.setup.feeSetup.feeType') }}</label>
                <a-select
                  style="width: 257px"
                  v-model="fee_type_id"
                  :options="getFeeType"
                  showSearch
                  mode="multiple"
                  :filterOption="filterOptions"
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ts-button
                color="primary"
                class="ts-w-full"
                @click="fetchData"
                :waiting="loading"
                >{{ $t('view') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </a-drawer>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce, trim } from 'lodash'
import FormComponent from './copy-fee'
import * as FileDownload from 'downloadjs'
import iTable from '@/store/i-table-helper'

export default {
  name: 'feeSetup',
  data() {
    return {
      loading: false,
      waiting_fetch: false,
      branchs: [],
      academicYear: [],
      visible: false,
      exporting: false
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
  },
  computed: {
    ...mapState('feeSetup', ['resources', 'pagination', 'feeTypes']),
    defaultBranchId() {
      return this.$store.state.authUser.default_branch_id
    },
    groupResources() {
      return iTable.rowGroup(this.resources, 'fee_type.fee_type_name')
    },
    getFeeType() {
      return this.feeTypes.map(el => ({
        value: el.value,
        label: el.text
      }))
    },
    search: {
      get() {
        return this.$store.state.feeSetup.search
      },
      set(newValue) {
        this.$store.commit('feeSetup/SET_SEARCH', newValue)
        this.$store.commit('feeSetup/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.feeSetup.branch_id
      },
      set(newValue) {
        this.$store.commit('feeSetup/SET_BRANCH_ID', newValue)
      }
    },
    ac_year_id: {
      get() {
        return this.$store.state.feeSetup.ac_year_id
      },
      set(newValue) {
        this.$store.commit('feeSetup/SET_ACADEMIC_YEAR_ID', newValue)
      }
    },
    fee_type_id: {
      get() {
        return this.$store.state.feeSetup.fee_type_id
      },
      set(newValue) {
        this.$store.commit('feeSetup/SET_FEE_TYPE_ID', newValue)
      }
    },
    columns() {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15,
          className: 'text-primary bold'
        },
        {
          title: this.$t('school.payment.setup.feeSetup.branch'),
          minWidth: 100,
          slot: 'branch_name_en'
        },
        {
          title: this.$t('school.payment.setup.feeSetup.feeName'),
          key: 'fee_name_en',
          minWidth: 180
        },
        {
          title: this.$t('school.payment.setup.feeSetup.termSemesterOrder'),
          key: 'term_semester_order',
          minWidth: 180,
          align: 'center'
        },
        {
          title: this.$t('school.payment.setup.feeSetup.amount'),
          minWidth: 120,
          key: 'fee_amount',
          align: 'center'
        },
        {
          title: this.$t('school.payment.setup.feeSetup.grade'),
          align: 'center',
          slot: 'grade_name_foreign',
          minWidth: 120
        },
        {
          title: this.$t('school.payment.setup.feeSetup.paymentTerm'),
          align: 'center',
          slot: 'payment_term',
          minWidth: 160
        },
        {
          title: this.$t('school.payment.setup.feeSetup.shift'),
          align: 'center',
          slot: 'shift_en',
          minWidth: 120
        },
        {
          title: this.$t('school.payment.setup.feeSetup.mainProgram'),
          slot: 'grade',
          minWidth: 210
        },
        {
          title: this.$t('school.payment.setup.feeSetup.academicYear'),
          slot: 'academic_year',
          minWidth: 210
        },
        {
          title: this.$t('school.payment.setup.feeSetup.distance'),
          align: 'center',
          minWidth: 120,
          slot: 'distance_description'
        },
        {
          title: this.$t('school.payment.setup.feeSetup.transaction'),
          align: 'center',
          slot: 'way_description',
          minWidth: 120
        },
        {
          title: this.$t('school.payment.setup.feeSetup.createdBy'),
          minWidth: 120,
          slot: 'loginname'
        },
        {
          title: this.$t('school.payment.setup.feeSetup.createdDate'),
          key: 'created_date',
          minWidth: 170
        },
        {
          title: this.$t('school.payment.setup.feeSetup.inActive'),
          minWidth: 120,
          slot: 'inactive',
          align: 'center'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    },
    displayMainProgram: () => record => {
      if (!record) return null
      const { level } = record
      if (level) {
        const { sub_program } = level
        return sub_program.main_program.acp_name_foreign
      }
      return null
    }
  },
  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'feeSetup/fetch',
          Object.assign(
            {
              page: this.pagination.currentPage,
              fee_type_id: this.fee_type_id,
              branch_id: this.branch_id
            },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async getBranch() {
      return this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(record) {
      this.$store.commit('feeSetup/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'fee-setup-edit',
        params: { id: record.fee_setup_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('feeSetup/destroy', record.fee_setup_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    showFormCopy() {
      this.$modal.show(
        FormComponent,
        {},
        {
          height: 'auto',
          width: '20%',
          scrollable: true,
          clickToClose: false
        }
      )
    },
    onCloseDrawer() {
      this.visible = false
    },
    exportExcel() {
      this.exporting = true

      this.$store
        .dispatch('feeSetup/exportExcel', {
          branch_id: this.branch_id,
          fee_type_id: this.fee_type_id,
          ac_year_id: this.ac_year_id,
          search: this.search
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    },
    async setToInactive(record) {
      if (
        await this.$confirmModal.danger(
          this.$t('school.payment.setup.feeSetup.are_you_sure_to_inactive'),
          this.$t('school.payment.setup.feeSetup.inActive')
        )
      ) {
        record.inactive = true
        this.$store
          .dispatch('feeSetup/setInactive', record.fee_setup_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    },
    async fetchAcademicYear() {
      return this.$store.dispatch('feeSetup/getAcademicYear', {
        branch_id: this.branch_id
      })
    },
    async onBranchgChange() {
      this.ac_year_id = undefined
      this.waiting_fetch = true
      const academicYear = await this.fetchAcademicYear()
      this.academicYear = academicYear.academic_years.map(el => ({
        value: el.ac_year_id,
        label: `${el.ac_year} - ${el.ac_status_description}- ${el.branch_name_en}`
      }))
      this.waiting_fetch = false
    },
    async showFilter() {
      this.visible = true
      this.waiting_fetch = true
      if (this.academicYear.length == 0) {
        const academicYear = await this.fetchAcademicYear()
        this.academicYear = academicYear.academic_years.map(el => ({
          value: el.ac_year_id,
          label: `${el.ac_year} - ${el.ac_status_description}- ${el.branch_name_en}`
        }))
      }
      if (this.branchs.length == 0) {
        await this.getBranch()
      }

      this.waiting_fetch = false
    },
    filterOptions(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    fee_type_id: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'fee-setup-create') {
      this.$store.commit('feeSetup/RESET_STATE')
    }
    next()
  }
}
</script>
